import type { QueryClient } from '@tanstack/react-query'
import { getNotificationsPulse } from '../api'
import { notificationQueryKeys } from './notificationQueryKeys'
import { INITIAL_PULSE, type PulseSnapshot } from '../utils/pulseUtils'

export const refreshNotificationsPulse = async (
  queryClient: QueryClient
): Promise<void> => {
  try {
    const result = await getNotificationsPulse()
    if (result.status === 304) {
      return
    }

    queryClient.setQueryData<PulseSnapshot>(notificationQueryKeys.pulse(), {
      unreadCount: result.data.unreadCount,
      headId: result.data.headId,
    })
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[notifications] pulse refresh failed', error)
    }
  }
}

export const resetNotificationsPulse = (queryClient: QueryClient): void => {
  queryClient.setQueryData<PulseSnapshot>(
    notificationQueryKeys.pulse(),
    INITIAL_PULSE
  )
}
